import { useEffect, useState } from "react";

/**
 * Odliczanie do emisji odcinka.
 *
 * `titles.next_airing_at` było wypełniane z AniLista **i nieużywane** — termin
 * następnego odcinka leżał w bazie, a na stronie tytułu nie było go widać.
 *
 * Takt zależy od tego, ile zostało: przy trzech dniach sekundy są szumem,
 * a przy trzech minutach są całą treścią. Stoper co sekundę przez trzy dni to
 * dwieście sześćdziesiąt tysięcy przerysowań bez powodu.
 */

function tickFor(msLeft: number): number {
  if (msLeft < 60_000) return 1000;
  if (msLeft < 3_600_000) return 30_000;
  return 300_000;
}

/** „za 2 dni 4 godz.", „za 12 min", „już poszedł". */
export function formatCountdown(msLeft: number): string {
  if (msLeft <= 0) return "już wyemitowany";

  const minutes = Math.floor(msLeft / 60_000);
  if (minutes < 1) return "za mniej niż minutę";
  if (minutes < 60) return `za ${minutes} min`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    const rest = minutes % 60;
    return rest === 0 ? `za ${hours} godz.` : `za ${hours} godz. ${rest} min`;
  }

  const days = Math.floor(hours / 24);
  const restHours = hours % 24;
  // Dni odmieniamy: „1 dzień", „2 dni". Bez tego czyta się jak komunikat maszyny.
  const dayLabel = days === 1 ? "1 dzień" : `${days} dni`;
  return restHours === 0 ? `za ${dayLabel}` : `za ${dayLabel} ${restHours} godz.`;
}

export function AiringCountdown({
  airingAt,
  episode,
  className,
}: {
  airingAt: string;
  episode: number | null;
  className?: string;
}) {
  const target = Date.parse(airingAt);
  const [msLeft, setMsLeft] = useState(() => target - Date.now());

  useEffect(() => {
    if (!Number.isFinite(target)) return;
    // Takt przeliczamy przy każdym tyknięciu: odliczanie schodzące z godzin do
    // minut ma przyspieszyć samo, bez osobnego stopera pilnującego stopera.
    const timer = setTimeout(() => setMsLeft(target - Date.now()), tickFor(msLeft));
    return () => clearTimeout(timer);
  }, [target, msLeft]);

  if (!Number.isFinite(target)) return null;

  return (
    <span className={className}>
      {episode !== null && `Odcinek ${episode} `}
      <span className="tabular-nums">{formatCountdown(msLeft)}</span>
    </span>
  );
}
